export const markUrl = (key, value, set = true) => {
  const url = new URL(window.location);

  if (set) url.searchParams.set(key, value);
  else url.searchParams.delete(key);

  window.history.pushState('', '', url.href);
};
